<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-card
          color="#ffffff"
          elevation="2"
        >
          <chart
            v-if="!isFetchingStatistics"
            :customer-stats="customerStats"
          />
        </v-card>
      </v-col>
    </v-row>
    <statistics
      v-if="!isFetchingStatistics"
      :customer-stats="customerStats"
    />
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <base-material-stats-card
          color="info"
          icon="mdi-chart-timeline-variant-shimmer "
          :title="allNameSpacesTitle"
          :value="allTimeCounter"
          sub-icon="mdi-clock"
          :sub-text="updateDate"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <base-material-stats-card
          color="#cc0000"
          icon="mdi-school"
          :title="ramReg"
          :value="ramRegistations"
          sub-icon="mdi-clock"
          :sub-text="updateDate"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <base-material-stats-card
          color="primary"
          icon="mdi-poll"
          :title="sevenDaysAgo"
          :value="lastWeekCounter"
          sub-icon="mdi-clock"
          :sub-text="updateDate"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <base-material-stats-card
          color="success"
          icon="mdi-clock"
          :title="last24h"
          :value="lastDayCounter"
          sub-icon="mdi-clock"
          :sub-text="updateDate"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { germanDateFormater } from '@/utils/germanDateFormater'
  import Chart from '../../views/dashboard/component/Chart.vue'
  import Statistics from './pages/Statistics.vue'
  import { getFirebaseToken } from '@/firebase'
  export default {
    name: 'DashboardDashboard',
    components: {
      Chart,
      Statistics,
    },
    data () {
      return {
        allNameSpacesTitle: this.$t('allRegisteredDomains'),
        ramReg: this.$t('ram-reg'),
        sevenDaysAgo: this.$t('seven-days-ago'),
        last24h: this.$t('last-24h'),
        customerStats: {},
        isFetchingStatistics: true,
      }
    },
    computed: {
      updateDate () {
        const day = new Date(Date.now())
        return `${this.$t('updated')}: ${germanDateFormater(day)}`
      },
      allTimeCounter () {
        // param 'all' is required
        return this.customerStats.totalCustomer
      },
      lastWeekCounter () {
        return this.customerStats.weeklyCount
      },
      lastDayCounter () {
        return this.customerStats.DailyCount
      },
      ramRegistations () {
        return this.customerStats.totalRamDomain
      },
    },
    mounted () {
      this.fetchDataSeries()
    },
    methods: {
      async fetchDataSeries () {
        const response = await fetch(
          `${process.env.VUE_APP_FUNCTIONS}/fetchCustomerStats`,
          {
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + (await getFirebaseToken()),
              'Content-Type': 'application/json;charset=UTF-8',
            },
          })
        const responseJson = await response.json()
        this.customerStats = responseJson.results
        this.isFetchingStatistics = false
      },
    },
  }
</script>
